import { useQuery } from '@tanstack/react-query';
import { Partner } from '../../models/partner.ts';
import { fetchPartners } from '../../api/partner.ts';

export default function usePartners() {
  const queryFn = fetchPartners;
  return useQuery<Partner[]>({ queryKey: ['partners'], queryFn });
}
